import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';

import {
  AppMultiSelect,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../helpers/Translator';
import { axiosPath } from '../../../../routing/helpers/router';
import ErrorHandler from '../../error/ErrorHandler';
import useIsMounted from '../../hooks/useIsMounted';

export default function SelectPlants(props) {
  const {
    onHandleChange,
    value,
    error,
    type = 'all',
    elements = [],
    format = 'p',
    title = <Translator file="user" name="user.plants" />,
    className = 'mb-2',
    isMulti = false,
    clientID = null,
    reset = false,
    onlyUsers = false,
    useHex = false,
    isSubmodule = false,
    isClearable = false,
  } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [options, setOptions] = useState(isMulti ? [] : null);

  const loadPlants = useCallback(
    async () =>
      axios
        .post(axiosPath('api_r_user_global_getPlants'), {
          type,
          elements,
          format,
          onlyUsers,
          useHex,
          isSubmodule,
        })
        .then((r) => {
          if (isMounted.current) {
            setOptions(r.data);
          }
        })
        .catch((e) => dispatch(ErrorHandler(e))),

    []
  );

  useEffect(() => {
    setOptions(null);
    loadPlants();
  }, [reset]);

  if (isMulti) {
    return (
      <AppMultiSelect
        icon={<AppRemixIcon icon="building-4" />}
        options={options}
        title={title}
        placeholder={ReactDOMServer.renderToString(
          <Translator file="user" name="select.one.or.multiple.plants" />
        )}
        value={value ?? []}
        onChange={(opt) => onHandleChange(opt)}
        isLoading={!options}
        error={error}
        isClearable={isClearable}
        hasSearchBox
        hasSelectOptions
      />
    );
  }

  return (
    <AppSingleSelect
      icon={<AppRemixIcon icon="building-4" />}
      options={options}
      title={title}
      placeholder={ReactDOMServer.renderToString(
        <Translator file="admin" name="client.plant.select-a-installations" />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isLoading={!options}
      error={error}
      isClearable={isClearable}
      hasSearchBox
    />
  );
}
